import Route from '@ember/routing/route'

interface Params extends Record<string, unknown> {
  share_id: string
}

export default class extends Route {
  model(params: Params) {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    return { shareId: params.share_id, subscriptionType }
  }
}
